import { useState, useEffect } from 'react';

export default function ScreenSizeWarning() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setShowWarning(window.innerWidth < 1280);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (!showWarning) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-amber-500 text-white px-4 py-2 text-center z-50 shadow-lg">
      <p className="text-sm font-medium">
        ⚠️ 建议使用宽度至少为 1280px 的浏览器窗口以获得最佳预览体验
      </p>
    </div>
  );
}
